import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import frenchMessages from "ra-language-french";
import russianMessages from "ra-language-russian";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { raSupabaseFrenchMessages } from "ra-supabase-language-french";
import { englishCrmMessages } from "./englishCrmMessages";
import { frenchCrmMessages } from "./frenchCrmMessages";
import { russianCrmMessages } from "./russianCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const raSupabaseFrenchMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Consultez vos emails pour trouver le message de reinitialisation du mot de passe.",
    },
  },
};

const raSupabaseRussianMessages = {
  "ra-supabase": {
    auth: {
      email: "Email",
      confirm_password: "Подтверждение пароля",
      sign_in_with: "Войти через %{provider}",
      forgot_password: "Забыли пароль?",
      reset_password: "Сбросить пароль",
      password_reset:
        "Пароль сброшен. Вы получите письмо со ссылкой для входа.",
      missing_tokens: "Отсутствуют токены доступа и обновления",
      back_to_login: "Назад ко входу",
    },
    reset_password: {
      forgot_password: "Забыли пароль?",
      forgot_password_details: "Введите email — отправим инструкции.",
    },
    set_password: {
      new_password: "Придумайте пароль",
    },
    validation: {
      password_mismatch: "Пароли не совпадают",
    },
  },
};

const raSupabaseRussianMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Проверьте почту: должно прийти письмо для сброса пароля.",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

const frenchCatalog = mergeTranslations(
  englishCatalog,
  frenchMessages,
  raSupabaseFrenchMessages,
  raSupabaseFrenchMessagesOverride,
  frenchCrmMessages,
);

const russianCatalog = mergeTranslations(
  englishCatalog,
  russianMessages,
  raSupabaseRussianMessages,
  raSupabaseRussianMessagesOverride,
  russianCrmMessages,
);

export const getInitialLocale = (): "en" | "fr" | "ru" => {
  const envLocale = import.meta.env.VITE_DEFAULT_LOCALE;

  if (envLocale === "en" || envLocale === "fr" || envLocale === "ru") {
    return envLocale;
  }

  if (typeof navigator === "undefined") {
    return "ru";
  }

  const browserLocale = navigator.languages?.[0] ?? navigator.language;
  const lower = browserLocale?.toLowerCase() ?? "";

  if (lower.startsWith("fr")) {
    return "fr";
  }
  if (lower.startsWith("en")) {
    return "en";
  }
  if (lower.startsWith("ru")) {
    return "ru";
  }

  return "ru";
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "fr") {
      return frenchCatalog;
    }
    if (locale === "ru") {
      return russianCatalog;
    }
    return englishCatalog;
  },
  getInitialLocale(),
  [
    { locale: "ru", name: "Русский" },
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
